// Packages
import React from 'react';
import '../css/components/moviesContent.css';

import { Link, withRouteData, Head, withSiteData } from 'react-static'
import axios from 'axios';
import Navigation from '../Nav.js';
import MovieFeed from "../sections/modules/MovieFeed";
import ReactHtmlParser from "react-html-parser";
import helpers from '../helpers';


export default withRouteData(class Movies extends React.Component {
    constructor(props) {
            super(props);

            this.state = {
                
            };
        }

    render() {
        const defaultCanonical = helpers.forceTrailingSlash(this.props.siteRoot + this.props.history.location.pathname);
        const yoastCanonical = helpers.forceTrailingSlash(this.props.movies[0].yoast_meta.yoast_wpseo_canonical);

        if (typeof document !== 'undefined') {
            return (
                <div>
                    <Navigation/>
                    <Head>
                        <body className={'home ' + this.props.movies[0].acf.global_page_color} />
                        {(this.props.movies[0].yoast_meta.yoast_wpseo_title) ? <title>{this.props.movies[0].yoast_meta.yoast_wpseo_title}</title> : ""}
                        {(this.props.movies[0].yoast_meta.yoast_wpseo_metadesc) ? <meta name="description" content={this.props.movies[0].yoast_meta.yoast_wpseo_metadesc} /> : ""}
                        {/* {(this.props.movies[0].yoast_meta.yoast_wpseo_canonical) ? <link rel="canonical" href={this.props.movies[0].yoast_meta.yoast_wpseo_canonical} /> : ""} */}
                        {(yoastCanonical.includes('imaginuitycenters')) ? 
                            <link rel="canonical" href={defaultCanonical} /> 
                        : 
                            <link rel="canonical" href={yoastCanonical} />
                        }
                    </Head>
                    {(this.props.movies[0].acf.header_featured_image_desktop) ?
                        <div id="heroSection">
                            <img className="hidden-xs" src={this.props.movies[0].acf.header_featured_image_desktop.url}
                                 alt={this.props.movies[0].acf.header_featured_image_desktop.alt}/>
                            <img className="visible-xs" src={this.props.movies[0].acf.header_featured_image_mobile.url}
                                 alt={this.props.movies[0].acf.header_featured_image_mobile.alt + ' mobile'}/>
                            <div className="hero-container">
                                {this.props.movies[0].acf.additional_content &&
                                <div className="hero-content hidden-xs">
                                    {(this.props.movies[0].acf.subheading) ? <h2>{ReactHtmlParser(this.props.movies[0].acf.subheading)}</h2> : ""}
                                    {(this.props.movies[0].acf.content) ? <div>{ReactHtmlParser(this.props.movies[0].acf.content)}</div> : ""}
                                </div>
                                }
                                <div className="hero-heading">{(this.props.movies[0].acf.title) ?
                                    <h1>{ReactHtmlParser(this.props.movies[0].acf.title)}</h1> :
                                    <h1>{ReactHtmlParser(this.props.movies[0].title.rendered)}</h1>}</div>
                            </div>
                        </div>
                        : ""}
                        <div className={'template-movies'}> 
                             <MovieFeed optionsData={this.props.property_options} pageData={this.props.movies[0]} />
                        </div>
                </div>
            )
        } else {
            return null
        }
}
})




// WEBPACK FOOTER //
// /opt/build/repo/src/pages/Movies.js